import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../components';

import css from './Section.module.css';

const MarketplaceSectionHeader = props => {
  const { title, description, headerAction, className } = props;
  const hasHeaderAction = headerAction?.name && headerAction?.label;

  return (
    <div className={classNames(css.marketplaceSectionHeader, className)}>
      <div className={css.marketplaceSectionHeaderTopRow}>
        <div className={css.marketplaceSectionHeaderTitleWrap}>
          <h2 className={css.marketplaceSectionHeaderTitle}>{title}</h2>
        </div>

        {hasHeaderAction ? (
          <NamedLink
            className={css.marketplaceSectionHeaderAction}
            name={headerAction.name}
            params={headerAction.params}
            to={headerAction.to}
          >
            {headerAction.label}
          </NamedLink>
        ) : null}
      </div>

      {description ? (
        <p className={css.marketplaceSectionHeaderDescription}>{description}</p>
      ) : null}
    </div>
  );
};

export default MarketplaceSectionHeader;
